import {SxProps} from "@mui/material";

export const showOverflowOnHoverSx: SxProps = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '&:hover': {
        overflow: 'visible',
        textOverflow: 'unset',
        backgroundColor: 'background.paper',
        zIndex: 100,
    },
};
